import Leaderboard from 'js/pixi/leaderboard';
import * as PIXI from 'pixi.js';
import Coin from '../pixi/Coin';
import Configuration from '../pixi/Configuration';
import Header from '../pixi/Header';
import SkinShop from '../pixi/SkinShop';
import DailyChallenge from '../pixi/DailyChallenge';
import Arrows from 'js/pixi/BonusItems/arrows';
import Shield from 'js/pixi/BonusItems/shield';
import RewardEffect from 'js/pixi/rewardEffect';
import GameManager from './GameManager';
import config from 'config';

class PixiManager {
    constructor() {
        // Header of the game
        this._header = null;

        // Coin of the game
        this._coin = null;

        // Skin shop of the game
        this._skinShop = null;

        // Is platform facebook
        this._isFacebook = GameManager.H5SDK.getPlatform().isFacebook();
        //for debug
        // this._isFacebook = false;
    }

    /**
     * Public
     */

    setup() {
        // Pixi basic
        this.view = document.getElementById("pixi");
        this.view.style.width = "100%";
        this.view.style.height = "100%";
        this.view.style.position = "absolute";
        this.view.style.top = "0px";
        this.view.style.left = "0px";
        this.view.style["z-index"] = "200";
        this.view.addEventListener("touchstart", (event) => {
            event.preventDefault();
        });
        //this.view.style["pointer-events"] ="none";
        //document.body.appendChild(this.view);

        this.app = new PIXI.Application({
            view: this.view,
            width: 1,
            height: 1,
            backgroundAlpha: 0x000000,
            resolution: window.devicePixelRatio,
            autoDensity: true,
            antialias: true,
            //resizeTo: window,
            //resizeTo: HTMLElement,
        });

        // const container = new PIXI.Container();

        // this.app.stage.addChild(container);

        // Add configuration to the app
        this._configuration = new Configuration();
        this.app.stage.addChild(this._configuration);

        // Add header to the app
        this._header = new Header();
        this.app.stage.addChild(this._header);

        // Add coin to the app
        this._coin = new Coin();
        this.app.stage.addChild(this._coin);


        // Add daily challenge to the app

        this._dailyChallenge = new DailyChallenge();
        this._dailyChallenge.scale.set(1.5);
        this.app.stage.addChild(this._dailyChallenge);
        this._dailyChallenge.default = true;


        // Add Arrows booster
        this._arrowItems = new Arrows();
        this.app.stage.addChild(this._arrowItems);

        // Add Shield booster
        this._shieldItems = new Shield();
        this.app.stage.addChild(this._shieldItems);

        // Add skin shop to the app
        this._skinShop = new SkinShop();
        this.app.stage.addChild(this._skinShop);

        // Add leaderboard to the app
        this._leaderBoard = new Leaderboard(this.view);
        this.app.stage.addChild(this._leaderBoard);

        // Add RewardEffect to the app
        this._rewardEffect = new RewardEffect();
        this.app.stage.addChild(this._rewardEffect);

    }

    get leaderBoard() {
        return this._leaderBoard;
    }

    get header() {
        return this._header;
    }

    get arrowItems() {
        return this._arrowItems;
    }

    get shieldItems() {
        return this._shieldItems;
    }

    get rewardEffect() {
        return this._rewardEffect;
    }

    get coin() {
        return this._coin;
    }

    update() {
        this._leaderBoard && this._leaderBoard.update();
    }

    notifyLevelStart() {
        // Notify the skin shop to hide the button
        this._skinShop.notifyLevelStart();

        // Notify the daily challenge to start the mission
        this._dailyChallenge && this._dailyChallenge.notifyLevelStart();

        // Notify the bonus items to start the mission
        if (GameManager._nbGamePlayed == 0) {
            this._arrowItems.notifyLevelStart();
            this._shieldItems.notifyLevelStart();
        }
    }

    restart() {
        // Restart the header with all the player list
        this._header.restart();

        // Restart the skin shop to show the button
        this._skinShop.restart();

        // Restart the daily challenge
        this._dailyChallenge && this._dailyChallenge.restart();

    }

    resize(w, h, coef) {
        // Resize the header
        this._header.resize(w, h, coef);

        // Resize the coin
        this._coin.resize(w, h, coef);

        // Resize the skin shop
        this._skinShop.resize(w, h, coef);

        // Resize the arrowItems
        this._arrowItems.resize(w, h, coef);

        // Resize the shieldItems
        this._shieldItems.resize(w, h, coef);

        this._leaderBoard && this._leaderBoard.resize(w, h);

        this._dailyChallenge && this._dailyChallenge.resize(w, h);

        this.app.renderer.resize(w, h);

        console.log("PixiManager resize:",)
    }

    updateScore(score) {
        this._header.updateScore(score);
    }

    updateCoin(coin) {
        this._skinShop.updateCoin(coin);
        this._coin.updateCoin(coin);
    }

    changeSkin(skinName) {
        this._skinShop.changeSkin(skinName);
    }

    notEnoughCoin() {
        this._coin.notEnoughCoin();
    }

    updateDailyChallenge(dailyChallengeData) {
        this._dailyChallenge && this._dailyChallenge.updateDailyChallenge(dailyChallengeData);
    }

    changeChallenger() {
        // this._dailyChallenge && this._dailyChallenge.changeChallenger();
    }


    setObjectifDatas() {

        console.log("setObjectifDatas");

        //looking for an opponent

        let opponentExist;

        console.log("UI setObjectifDatas (reconnected):", config.reconnected);
        console.log("UI setObjectifDatas (invite friend):", config.inviteFriend);

        for (let i = 0; i < config.friends.length; i++) {
            if (config.friends[i].isOpponent) {
                opponentExist = true;
            }
        }

        console.log("opponentExist in config.friends:", opponentExist);

        if (config.reconnected || config.inviteFriend || config.currentContext || opponentExist) {

            config.inviteFriend = false;
            this.getOpponent();

        } else {

            console.log("no context, start classic objectif");
            this._dailyChallenge && (this._dailyChallenge.default = true);

        }


    };




    getOpponent() {



        GameManager.H5SDK.getProfileModule().getOpponent().then(value => {
            console.log("retour de getOpponent :", value);

            this.currentContext = GameManager.H5SDK.getContextModule().getCurrentContext().id;
            this.currentContext = Math.random() * 10000;

            console.log("currentContext:", config.currentContext);
            console.log("new currentContext:", this.currentContext);

            if (value) {

                var value = value.length > 0 ? value[0] : value;

                // //debug
                // value.isOpponent = true;
                // value.isRealScore = true;
                // value.score = 100;
                // //end debug

                this._dailyChallenge.opponent = value;

                if (value.isRealScore) {

                    console.log("===== isRealScore true =======");
                    console.log("this.currentContext:", this.currentContext);
                    console.log("beatenOpponent:", config.beatenOpponent);
                    console.log("==============================");

                    if (config.beatenOpponent.indexOf(this.currentContext) != -1) {
                        this._dailyChallenge.default = true;
                        return;
                    }

                    // => "Beat your friend's score";
                    this._dailyChallenge.realScore = true;
                    this._dailyChallenge.default = false;

                } else {

                    if (config.currentContext == this.currentContext) {
                        this._dailyChallenge.default = true;
                        return;
                    }

                    // => "Make the highest score to challenge your friend";
                    this._dailyChallenge.realScore = false;
                    this._dailyChallenge.default = false;

                }


            } else {

                this._dailyChallenge.default = true;

            }

            config.currentContext = this.currentContext;

        });

    }





}

export default PixiManager;